import React, { useRef, useState } from 'react';
import dateFormat from 'dateformat';
import classnames from 'classnames';
import CalendarForm from './CalendarForm';


function toInteger (value, min, max) {
  let fixedValue = parseInt(value);
  if (!fixedValue) {
    fixedValue = 0;
  }

  if (min && min > fixedValue) {
    return min;
  } else if (max && max < fixedValue) {
    return max;
  } else {
    return fixedValue;
  }
}


export default function DateForm ({ published, onChange }) {
  const selectedDate = new Date(published * 1000);

  const btnCalendar = useRef(null);
  const [openCalendar, setOpenCalendar] = useState(false);
  const [dateString, setDateString] = useState(dateFormat(selectedDate, 'yyyy-mm-dd'));
  const [hours, setHours] = useState(selectedDate.getHours());
  const [minutes, setMinutes] = useState(selectedDate.getMinutes());

  function handleToggleCalendar (e) {
    e.preventDefault();
    e.stopPropagation();

    setOpenCalendar(!openCalendar);
  }

  function handleCloseCalendar (e) {
    if (e.target === btnCalendar.current) {
      return;
    }
    setOpenCalendar(false);
  }

  function handleChange () {
    onChange(parseInt(selectedDate.getTime() / 1000));
  }

  function handleCheckDate () {
    const limit = new Date(new Date().getTime() + 86400);
    if (selectedDate.getTime() < limit.getTime() - 86400) {
      setDateString(dateFormat(limit, 'yyyy-mm-dd'));
      setHours(limit.getHours());
      setMinutes(limit.getMinutes());
    }
  }

  function handleChangeDate (year, month, day) {
    selectedDate.setFullYear(year, month, day);
    setDateString(dateFormat(selectedDate, 'yyyy-mm-dd'));
    setOpenCalendar(false);
    handleCheckDate();
    handleChange();
  }

  function handleChangeHour (e) {
    const value = toInteger(e.target.value, 0, 23);
    e.target.value = value;
    setHours(value);
    selectedDate.setHours(value);
    handleChange();
  }

  function handleChangeMinute (e) {
    const value = toInteger(e.target.value, 0, 59);
    e.target.value = value;
    setMinutes(value);
    selectedDate.setMinutes(value);
    handleChange();
  }

  return (
    <div className="wrap_date">
      <div className={classnames('box_date', { on: openCalendar })}>
        <button ref={btnCalendar} type="button" className="btn_reserve" onClick={handleToggleCalendar}>
          {dateString}
        </button>
      </div>

      {openCalendar &&
        <CalendarForm
          selectedDate={selectedDate}
          onChange={handleChangeDate}
          onClose={handleCloseCalendar}
        />
      }

      <div className="box_date">
        <input
          type="number" min="0" max="23"
          name="dateHout"
          id="dateHout"
          className="inp_g"
          title="시간"
          value={hours}
          onChange={handleChangeHour}
          onBlur={handleCheckDate}
        />
      </div>
      <span className="txt_date">:</span>
      <div className="box_date">
        <input
          type="number" min="0" max="59"
          name="dateMinute"
          id="dateMinute"
          className="inp_g"
          title="분"
          value={minutes}
          onChange={handleChangeMinute}
          onBlur={handleCheckDate}
        />
      </div>
    </div>
  );
}
